<div class="container">
  <div id="addNote" [ngClass]="{'add-note-minimized' : this.isMinimized, 'add-note-fullscreen' : !this.isMinimized, 'mat-elevation-z8': true}">
    <mat-expansion-panel [expanded]="showNoteForm" (opened)="addPanelOpen()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>note_add</mat-icon>
          Add Note
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form novalidate [formGroup]="noteForm">
        <mat-form-field>
          <mat-label>Note Type</mat-label>
          <mat-select formControlName="newNoteType">
            @for (noteType of noteTypes; track noteType) {
              <mat-option [value]="noteType.id">
                {{noteType.description}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div>
          <label for="newNote">Note:</label>
          <textarea id="newNote" formControlName="newNoteField" [disabled]="addingNote"></textarea>
          @if (newNoteFormIsInValid) {
            <mat-error>Note description required</mat-error>
          }
        </div>
        <div>
          <mat-checkbox formControlName="newNotePriority" color="warn">Priority</mat-checkbox>
        </div>
      </form>
      <mat-action-row>
        @if (addingNote) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        <button mat-button mat-raised-button [disabled]="addingNote" (click)="resetNewNoteFields()">Cancel</button>

        <button mat-button mat-raised-button color="primary" [disabled]="addingNote" (click)="newNoteFormSubmitted = true; addNote()">Save</button>
      </mat-action-row>
    </mat-expansion-panel>
  </div>
  @if (InternNotes && parentState == 1) {
    <table mat-table [dataSource]='InternNotes' class="mat-elevation-z8">
      <ng-container matColumnDef="Type">
        <th mat-header-cell *matHeaderCellDef> Type </th>
        <td mat-cell *matCellDef="let element"> {{element.categoryDescription}} </td>
      </ng-container>
      <ng-container matColumnDef="Note">
        <th mat-header-cell *matHeaderCellDef> Content </th>
        <td mat-cell *matCellDef="let element">
          @if (element.isEdit==false) {
            <div class="existingNote">
              <span [innerHtml]="element.note"> </span>
            </div>
            <br />
            <div>
              <button mat-button color="primary" class="editNoteButton" (click)="element.isEdit=true">Edit</button>
            </div>
          }
          @if (element.isEdit) {
            <div>
              <div class="existingNote">
                <span [innerHtml]="element.note"> </span>
              </div>
              <textarea [(ngModel)]="element.noteUpdate" class="updateNoteInput" [disabled]="updatingNote"></textarea>
              @if (updatingNote) {
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              }
              <button mat-raised-button (click)="element.isEdit=false" [disabled]="updatingNote">Cancel</button>
              <button mat-raised-button color="primary" (click)="updateDescription(element)" [disabled]="updatingNote">Save</button>
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="CreatedBy">
        <th mat-header-cell *matHeaderCellDef> Created By </th>
        <td mat-cell *matCellDef="let element"> {{element.createUser}} </td>
      </ng-container>
      <ng-container matColumnDef="CreatedDate">
        <th mat-header-cell *matHeaderCellDef> Created Date </th>
        <td mat-cell *matCellDef="let element"> {{element.createTimeDisplay | date: 'M/d/yyyy h:mm a'}} </td>
      </ng-container>
      <ng-container matColumnDef="UpdatedBy">
        <th mat-header-cell *matHeaderCellDef> Updated by </th>
        <td mat-cell *matCellDef="let element"> {{element.modUser}} </td>
      </ng-container>
      <ng-container matColumnDef="UpdateDate">
        <th mat-header-cell *matHeaderCellDef> Update Date </th>
        <td mat-cell *matCellDef="let element"> {{element.modDateTimeDisplay | date: 'M/d/yyyy h:mm a' }} </td>
      </ng-container>
      <ng-container matColumnDef="Priority">
        <th mat-header-cell *matHeaderCellDef> Priority </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox color="warn" [checked]="element.priority" [(ngModel)]="element.priority" (click)="$event.stopPropagation()" (change)="element.priority != element.priority; updatePriority(element)">
          </mat-checkbox>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    </table>
  }
  @if (parentState == 0) {
    <table class="compact-note-list">
      @for (note of InternNotes; track note) {
        <tr class="compact-note">
          <td>
            <div class="compact-note-head"> {{note.categoryDescription}}, {{note.createTimeDisplay | date:'M/d/yyyy h:mm a' }}  @if (note.priority) {
              <mat-icon>priority_high</mat-icon>
            }</div>
            <div class="compact-note-body">
              <span [innerHtml]="note.note"> </span>
            </div>
          </td>
        </tr>
      }
    </table>
  }
</div>
